import { React, useState, useRef, useEffect } from "react";
import {
  TableContainer, Tr, Td, Th, Table, Thead, Tbody, Icon, Button, Box, Heading,
  useToast, Modal,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, useDisclosure, Input, Select, Popover, PopoverTrigger, Portal
  , PopoverContent, PopoverArrow, PopoverHeader, Checkbox, CheckboxGroup, PopoverCloseButton, Stack, FormControl, FormLabel, PopoverFooter, PopoverBody, CloseButton, RadioGroup, Text, Radio, Textarea, HStack, Badge, Spacer, Tooltip, VStack
} from "@chakra-ui/react";
import { MdArrowBack, MdArrowForward, MdUploadFile, MdSearch, MdRestartAlt,MdDelete } from "react-icons/md";
import { GiCardExchange } from "react-icons/gi";
import { EditIcon, InfoIcon, SearchIcon } from '@chakra-ui/icons';
import { FaShareAlt } from "react-icons/fa";
import { IoWarning } from "react-icons/io5";
import { react_api } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import { CASE_TYPE } from "../CaseTypeCostant";
import createAxiosInstance from "../interceptors/useAxiosInterceptors"
import { useSession } from '../SessionContext';
import { useNavigate } from "react-router-dom";
import logout from "../services/authService";
import { Switch } from '@chakra-ui/react'
import { convertUtcToLocal } from "../services/utils";
import { useTranslation } from "react-i18next";
import { hasAccents } from "../services/utils";
import SpinnerXL from "./SpinnerXL";
import { getValidationMetadataMl, initSurveyService } from "../services/http/surveyHttpService";
import Draggable from 'react-draggable';
import { TbWorldUpload } from "react-icons/tb";
import { PiGraphFill } from "react-icons/pi";

function DatasetPage() {
  const role = sessionStorage.getItem("role");   
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [datasetList, setDatasetList] = useState([]);
  const [catalogCopy, setCatalogCopy] = useState([]);
  const [scrollBehavior, setScrollBehavior] = useState('inside')
  const categories = [
    'Agricoltura, pesca, silvicoltura e prodotti alimentari',
    'Economia e finanza',
    'Istruzione, cultura e sport',
    'Energia',
    'Ambiente',
    'Governo e settore pubblico',
    'Salute',
    'Tematiche internazionali',
    'Giustizia, sistema giuridico e sicurezza pubblica',
    'Regioni e città',
    'Popolazione e società',
    'Scienza e tecnologia',
    'Trasporti'
  ];

  const { t } = useTranslation();

  // Assign the global variable inside the component

  const [isUpdate, setIsUpdate] = useState(false);

  const [searchDescriptionInput, setSearchDescriptionInput] = useState("");
  const [searchManagerInput, setSearchManagerInput] = useState("");

  const [searchNameInput, setSearchNameInput] = useState("");
  const [searchDatasetIdInput, setSearchDatasetIdInput] = useState("");


  const [searchSelectedValue, setSearchSelectedValue] = useState('datasetId');
  const [selectedSearchVisibilityValues, setSelectedSearchVisibilityValues] = useState([]);

  const [allChecked, setAllChecked] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [catalog, setCatalog] = useState([]);
  const { isOpen: isUploadModalOpen, onOpen: onUploadModalOpen, onClose: onUploadModalClose } = useDisclosure();

  const fileFormats = [
    { label: "csv", value: [".csv"] },
    { label: "xlsx", value: [".xlsx", ".xls"] },
    { label: "shapefile", value: [".zip", ".rar"] },
    { label: "json", value: [".json"] },
    { label: "GeoJSON", value: [".geojson"] },
    { label: "GeoPackage", value: [".gpkg"] }
  ];
  const [selectedFileFormat, setSelectedFileFormat] = useState(fileFormats[0].value);


  const defaultPayloadUploadRequestValue = { version: "1.0", titolo: null, file: null, fileFormat: "csv", is_update: false }

  //Per l'upload del dataset
  const [payloadUploadRequest, setPayloadUploadRequest] = useState(defaultPayloadUploadRequestValue);

  const fileSelectorRef = useRef(null);
  const { isOpen: isConfirmOpen, onOpen: onConfirmOpen, onClose: onConfirmClose } = useDisclosure();
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure();
  
  const toast = useToast();
  const [activeIndex, setActiveIndex] = useState(null);
  //const onOpen = (index) => setActiveIndex(index);
  //const onClose = () => setActiveIndex(null);

  const [keys, setKeys] = useState([]);
  const { updateSessionData, clearSessionData } = useSession();

  const navigate = useNavigate();


  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });

  initSurveyService(t, toast, axiosInstance)

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= Math.ceil(catalog.length / itemsPerPage)) {
      setCurrentPage(newPage);
    }
  };


  const handleChangePayloadRequest = (event, key) => {

    switch (key) {


      case "version":
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: event
        }));
        break

      case "titolo":

        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: event.target.value
        }));
        break
      case "fileFormat":
        switch (event.target.selectedOptions[0].label) {
          case "csv":
            toast({
              title: t('toastMsg.datasetPage.info'),
              description: t('toastMsg.datasetPage.csvDelimiters'),
              status: 'info',
              duration: 4000,
              isClosable: true
            })
            break
          case 'shapefile':
            toast({
              title: t('toastMsg.datasetPage.info'),
              description: t('toastMsg.datasetPage.shapefileFormat'),
              status: 'info',
              duration: 4000,
              isClosable: true
            })


        }


        setSelectedFileFormat(event.target.value.split(","))

        let label = event.target.selectedOptions[0].label
        if (label == "GeoJSON")
          label = "geojson"

        if (label == "GeoPackage")
          label = "gpkg"
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: label
        }));
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          file: null
        }));

        fileSelectorRef.current.value = ""


        break

      case "file":

        let file = event.target.files[0]

        if (file) {
          const isValidExtension = selectedFileFormat.some(ext => file.name.endsWith(ext));
          if (!isValidExtension) {
            event.target.value = '';
            setPayloadUploadRequest(payloadUploadRequest => ({
              ...payloadUploadRequest,
              file: null
            }));
            return
          }
        }

        if (hasAccents(file.name)) {

          event.target.value = '';
          setPayloadUploadRequest(payloadUploadRequest => ({
            ...payloadUploadRequest,
            file: null
          }));

          toast({
            title: t('toastMsg.error'),
            description: t('toastMsg.datasetPage.fileNameCannotContainAccents'),
            status: 'warning',
            duration: 4000,
            isClosable: true
          })
          return
        }

        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: file
        }));

        break


      case "is_update":
        const { checked } = event.target;
        setIsUpdate(checked);

        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: checked
        }));

        break

      case "updateDate":
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: event.target.value
        }));
        break;

      default:
        break
    }





  };




  const handleSelectSearchChange = (event) => {

    setSearchSelectedValue(event.target.value);

  };

  const handleSearchDescriptionInput = (event) => {

    setSearchDescriptionInput(event.target.value);

  };

  const handleSearchManagerInput = (event) => {

    setSearchManagerInput(event.target.value);

  };


  const handleSearchNameInput = (event) => {

    setSearchNameInput(event.target.value);

  };
  const handleSearchDatasetIdInput = (event) => {

    setSearchDatasetIdInput(event.target.value);

  };


  const handleSelectedSearchVisibilityValuesChange = (event) => {

    setSelectedSearchVisibilityValues(event);

  };




  const [searchCheckedCategories, setSearchCheckedCategories] = useState(
    Array(categories.length).fill(false))



  const handleCategoryChange = (index) => (e) => {
    const updatedCheckedCategories = [...searchCheckedCategories];
    updatedCheckedCategories[index] = e.target.checked;
    setSearchCheckedCategories(updatedCheckedCategories);
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSearchCheckedCategories(Array(categories.length).fill(isChecked));
    setAllChecked(isChecked);
    setIsIndeterminate(false);
  };

  const [isMetadataModalOpen, setMetadataModalOpen] = useState(false);
  const [metadata, setMetadata] = useState();
  const [metadataTableName, setMetadataTableName] = useState("");
  const [datasetTableName, setDatasetTableName] = useState("");
  const [isEditDatasetModalOpen, setEditDatasetModalOpen] = useState(false);
  const [isDatasetModalOpen, setDatasetModalOpen] = useState(false);
  const [sharedUsersList, setSharedUsersList] = useState([]);
  const [tableId, setTableId] = useState();
  const [sharedUserName, setSharedUserName] = useState("");

  const [metadataDescription, setMetadataDescription] = useState([]);
  const [metadataValidationDatasetML, setMetadataValidationDatasetML] = useState([]);
  const [isMetadataDescModalOpen, setMetadataDescModalOpen] = useState(false);
  const [isMetadataModalValidationDatasetML, setMetadataModalValidationDatasetML] = useState(false);
  const [headersMetaDataML, setHeadersMetaDataML] = useState([]);


  const openMetadataDescriptionModal = () => {
    getTableCol(tableId).then(res => {
      setMetadataDescription(res.columns);
      setMetadataDescModalOpen(true);
    });
  };



  const openMetadataModalValidationDatasetML = () => {
    getValidationMetadataMl(metadata.id_validation_metadataml)
      .then(res => {
        const data = Array.isArray(res) ? res : [res];
        const headers = Object.keys(data[0]).filter(key => key !== "status" && key !== "message");
        setHeadersMetaDataML(headers);
        setMetadataValidationDatasetML(data);
        setMetadataModalValidationDatasetML(true);
      })
      .catch(error => {
        console.error("Errore nel recupero dei dati:", error);
      });
  };


  const closeMetadataDescriptionModal = () => {
    setMetadataDescription([]);
    // setDatasetTableName("");
    setMetadataDescModalOpen(false);
    setPosition({ x: 0, y: 0 });
  };

  const handleChengeUsernameUser = (event) => {
    const user = event.target.value
    setSharedUserName(user)
  }
  const openMetadataModal = (response, tableName) => {
    setDatasetTableName(tableName);
    setMetadata(response);
    setMetadataTableName(tableName);
    setSpinnerLoading(false);
    setMetadataModalOpen(true);
  };

  const openDatasetModal = (response, tableName) => {

    setKeys(Object.keys(response.previewTable[0]))
    setDatasetList(response.previewTable);
    setDatasetTableName(tableName);
    setSpinnerLoading(false);
    setDatasetModalOpen(true);
  };

  const closeMetadataModal = () => {
    setMetadataModalOpen(false);
  };
  const closeDatasetModal = () => {
    setDatasetModalOpen(false);
  };


  const openEditModal = (response, tableName, tableId) => {
    setTableId(tableId);
    setDatasetTableName(tableName);
    setSharedUsersList(response.grantee)
    setEditDatasetModalOpen(true);
  };

  const closeEditModal = () => {
    setEditDatasetModalOpen(false);
  };

  //Funzione per condividere il dataset con altri utenti
  const shareWithUser = async () => {
    try {
      setSpinnerLoading(true);
      if (sharedUserName != null && sharedUserName != "") {

        const richiesta = {
          BearerToken: sessionStorage.getItem("token"),
          username: sessionStorage.getItem("username"),
          tableName: datasetTableName,
          userNameForm: sharedUserName
        }
        /*const options = {
         
          headers: {
            'Content-Type': 'application/json',
          },
          
        }*/
        const urlFetch = `${react_api}/privateCatalog/uploadGrantADP`;
        const response = await axiosInstance.post(urlFetch, richiesta, {

          headers: {
            'Content-Type': 'application/json',
          },

        });
        const result = response.data;
        if (result.status.toString() === HTTP_STATUS_CODES.OK) {
          setSpinnerLoading(false);
          toast({
            title: t('toastMsg.datasetPage.shareSuccess'),
            description: t('toastMsg.datasetPage.sharedWith') + sharedUserName,
            status: 'info',
            duration: 4000,
            isClosable: true
          });

          closeEditModal();

        } else {
          setSpinnerLoading(false);
          throw new Error(t('catalog.dataset.throwNewError.dataRecoveryError'));
        }
      } else {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.datasetPage.emptyUsername'),
          description: t('toastMsg.datasetPage.enterUsername'),
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }

    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  }

  //Funzione per pubblicare il dataset 
  const publishDataset = async () => {

    try {
      setSpinnerLoading(true);
      const richiesta = {
        BearerToken: sessionStorage.getItem("token"),
        username: sessionStorage.getItem("username"),
        tableName: datasetTableName,
        tableId: tableId
      }
      const options = {

        headers: {
          'Content-Type': 'application/json',
        },

      }
      const urlFetch = `${react_api}/privateCatalog/datasetPublicationADP`;
      const response = await axiosInstance.post(urlFetch, richiesta, options);

      const result = response.data;
      if (result.status.toString() === HTTP_STATUS_CODES.OK) {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.datasetPage.publishSuccess'),
          description: response.data.message,
          status: 'info',
          duration: 4000,
          isClosable: true
        });

        setCatalog(prevCatalog =>
          prevCatalog.map(item =>
            item.tableId === tableId ? { ...item, visibility: "public" } : item
          )
        );
        closeEditModal()

      } else {
        setSpinnerLoading(false);
        throw new Error(t('catalog.dataset.throwNewError.dataRecoveryError'));
      }

    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  }


  const getSharedUsers = async (tableName, tableId) => {
    try {
      setSpinnerLoading(true);
      const richiesta = {
        BearerToken: sessionStorage.getItem("token"),
        username: sessionStorage.getItem("username"),
        tableId: tableId
      }
      const options = {

        headers: {
          'Content-Type': 'application/json',
        },

      }
      const urlFetch = `${react_api}/privateCatalog/getTableGranteeADP`;
      const response = await axiosInstance.post(urlFetch, richiesta, options);

      const result = response.data;
      if (result.status.toString() === HTTP_STATUS_CODES.OK) {
        setSpinnerLoading(false);
        openEditModal(response.data, tableName, tableId)


      } else {
        setSpinnerLoading(false);
        throw new Error(t('catalog.dataset.throwNewError.dataRecoveryError'));
      }

    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }



  }

  const getTableCol = async (id) => {
    try {
      const urlFetch = `${react_api}/stagingAreaResult/getTableColADP`;
      const response = await axiosInstance.post(urlFetch, { tableId: id }, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return null;
    }
  };

  const visualizzaMetadati = async (tableId, tableName) => {
    setTableId(tableId);
    try {
      setSpinnerLoading(true)
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },

      }
      const urlFetch = `${react_api}/getMetadataADP/${tableId}`;
      const response = await axiosInstance.get(urlFetch, options);

      if (response.status.toString() === HTTP_STATUS_CODES.OK) {
        openMetadataModal(response.data, tableName);


      } else {
        throw new Error(t('catalog.dataset.throwNewError.dataRecoveryError'));
      }

    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };


  const visualizzaDataset = async (tableId, TBL_NAME) => {
    setTableId(tableId);
    try {
      setSpinnerLoading(true)
      const body = {
         BearerToken: sessionStorage.getItem("token"),
        username: sessionStorage.getItem("username"),
        tableName: TBL_NAME,
      };
      const options = {

        headers: {
          'Content-Type': 'application/json',
          'Authorization': sessionStorage.getItem("token")
        },

      }
      const urlFetch = `${react_api}/getTableADP`;
      const response = await axiosInstance.post(urlFetch, body, options);
      const data = response.data;


      if (data.status === HTTP_STATUS_CODES.OK) {

        openDatasetModal(data, TBL_NAME)


      } else {
        throw new Error(t('catalog.dataset.throwNewError.dataRecoveryError'));
      }
    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };
  useEffect(() => {

    const user = sessionStorage.getItem('username');
    console.log(user);
    const allChecked = searchCheckedCategories.every(Boolean);
    const someChecked = searchCheckedCategories.some(Boolean);
    setAllChecked(allChecked);
    setIsIndeterminate(!allChecked && someChecked);


    const fetchCatalog = async () => {
      try {
        const richiesta = {
          BearerToken: sessionStorage.getItem("token"),
          username: sessionStorage.getItem("username"),
          caseType: CASE_TYPE.CATALOG_ALL,
        };

        const urlFetch = `${react_api}/privateCatalog/getCatalogADP`;

        // Make the POST request using Axios
        const response = await axiosInstance.post(urlFetch, richiesta, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const result = response.data;
        if (result.status === HTTP_STATUS_CODES.BAD_REQUEST || result.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
          toast({
            title: t('toastMsg.error'),
            description: t(`messageBE.${result.message}`),
            position: "top",
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }
        if (result.status === HTTP_STATUS_CODES.OK) {


          setCatalog(result.catalog.filter(cat => cat.visibility !== 'null'));
          setCatalogCopy(result.catalog.filter(cat => cat.visibility !== 'null'));
        } else {
          toast({
            title: t('toastMsg.datasetPage.emptyResultsTable'),
            description: String(t(`messageBE.${result.message}`)),
            position: "top",
            status: 'info',
            duration: 4000,
            isClosable: true,
          });
          setMessage(result.message);
        }
      } catch (error) {
        // Handle error response
        if (error.response) {
          // The request was made and the server responded with a status code
          toast({
            title: t('toastMsg.callError'),
            description: String(error.response.data.message || error.response.statusText),
            position: "top",
            status: 'warning',
            duration: 4000,
            isClosable: true,
          });
        } else if (error.request) {
          // The request was made but no response was received
          toast({
            title: t('toastMsg.callError'),
            description: t('toastMsg.datasetPage.noResponseServer'),
            position: "top",
            status: 'warning',
            duration: 4000,
            isClosable: true,
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          toast({
            title: t('toastMsg.callError'),
            description: String(error.message),
            position: "top",
            status: 'warning',
            duration: 4000,
            isClosable: true,
          });
        }
      }
    };
    fetchCatalog();
  }, [searchCheckedCategories]);


  const applyFilterDataset = () => {
    setSpinnerLoading(true)
    function updatePaginatedDate() {
      setCurrentPage(1)

      paginatedData = catalogFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
      totalPages = Math.ceil(catalogFiltered.length / itemsPerPage);

    }
    let catalogFiltered = catalogCopy
    if (selectedSearchVisibilityValues != null && selectedSearchVisibilityValues.length > 0) {

      catalogFiltered = catalogFiltered.filter(pageData => selectedSearchVisibilityValues.includes(pageData.visibility))
      updatePaginatedDate()
    }

    if (searchCheckedCategories != null && searchCheckedCategories.length > 0) {

      let categoriesFilter = []
      searchCheckedCategories.forEach((value, index) => {
        if (value)
          categoriesFilter.push(categories[index])
      });
      if (categoriesFilter != null && categoriesFilter.length > 0) {

        catalogFiltered = catalogFiltered.filter(pageData =>
          pageData.category.length > 0 && pageData.category.some(cat => categoriesFilter.includes(cat))
        );
        updatePaginatedDate()
      }

    }


    if (searchNameInput != null && searchNameInput.length > 0) {


      catalogFiltered = catalogFiltered.filter(pageData => pageData.TBL_NAME.toLowerCase() === searchNameInput.toLowerCase() || pageData.TBL_NAME.toLowerCase().includes(searchNameInput.toLowerCase()))
      updatePaginatedDate()


    }
    if (searchDatasetIdInput != null && searchDatasetIdInput.length > 0) {
      catalogFiltered = catalogFiltered.filter(pageData => pageData.ds_id.toLowerCase() === searchDatasetIdInput.toLowerCase() || pageData.ds_id.toLowerCase().includes(searchDatasetIdInput.toLowerCase()))
      updatePaginatedDate()
    }


    if (searchDescriptionInput != null && searchDescriptionInput.length > 0) {


      catalogFiltered = catalogFiltered.filter(pageData => pageData.description.toLowerCase() === searchDescriptionInput.toLowerCase() || pageData.description.toLowerCase().includes(searchDescriptionInput.toLowerCase()))
      updatePaginatedDate()


    }

    if (searchManagerInput != null && searchManagerInput.length > 0) {

      catalogFiltered = catalogFiltered.filter(pageData => pageData.OWNER.toLowerCase() === searchManagerInput.toLowerCase() || pageData.OWNER.toLowerCase().includes(searchManagerInput.toLowerCase()))
      updatePaginatedDate()
    }
    setSpinnerLoading(false)
    setCatalog(catalogFiltered)

  };

  const resetFilterDataset = () => {
    setCatalog(catalogCopy)
    setCurrentPage(1)
    paginatedData = catalog.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    totalPages = Math.ceil(catalog.length / itemsPerPage);
    setSelectedSearchVisibilityValues([])
    setSearchCheckedCategories(Array(categories.length).fill(false))
    setSearchDescriptionInput("")
    setSearchManagerInput("")
    setSearchNameInput("")
    setSearchDatasetIdInput("")
    setSearchSelectedValue("name")

  }


  const uploadDataset = async () => {
    if (payloadUploadRequest.is_update) {
      if (
        payloadUploadRequest.updateDate == null || payloadUploadRequest.updateDate.length === 0 ||
        payloadUploadRequest.file == null ||
        payloadUploadRequest.fileFormat == null
      ) {
        toast({
          title: t('toastMsg.error'),
          description: t('toastMsg.uploadDatasetModal.updateFile'),
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        return;
      }
    } else {
      if (
        payloadUploadRequest.titolo == null || payloadUploadRequest.titolo.length === 0 ||
        payloadUploadRequest.file == null ||
        payloadUploadRequest.fileFormat == null
      ) {
        toast({
          title: t('toastMsg.error'),
          description: t('toastMsg.uploadDatasetModal.newFile'),
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        return;
      }
    }

    try {
      setSpinnerLoading(true);

      const formData = new FormData();
      formData.append("username", sessionStorage.getItem("username"));

      Object.keys(payloadUploadRequest).forEach(payloadUploadRequestKey => {
        formData.append(payloadUploadRequestKey, payloadUploadRequest[payloadUploadRequestKey]);
      });

      const options = {
        headers: {
          "Authorization": sessionStorage.getItem("token")
        },
      };
      const urlFetch = `${react_api}/privateServices/uploadDataADP`;
      const response = await axiosInstance.post(urlFetch, formData, options);
      const result = response.data;

      switch (result.status) {
        case HTTP_STATUS_CODES.OK:
          setSpinnerLoading(false);
          toast({
            title: result.message,
            description: "",
            status: 'info',
            duration: 4000,
            isClosable: true
          });
          onUploadModalClose();
          setPayloadUploadRequest(defaultPayloadUploadRequestValue);
          break;

        case HTTP_STATUS_CODES.BAD_REQUEST:
          setSpinnerLoading(false);
          toast({
            title: result.message,
            description: "",
            status: 'warning',
            duration: 4000,
            isClosable: true
          });
          break;

        default:
          setSpinnerLoading(false);
          throw new Error(t('navbar.throwNewError.dataRecoveryError'));
      }

    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  }




  var paginatedData = catalog.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  var totalPages = Math.ceil(catalog.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage - 9;
  const endIndex = Math.min((currentPage) * itemsPerPage, catalog.length);

  const modalRef = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  // Funzione che controlla il trascinamento con limiti precisi
  const handleDrag = (e, data) => {
    if (!modalRef.current) return;
    const { x, y } = data;
    const modalRect = modalRef.current.getBoundingClientRect();
    const modalWidth = modalRect.width;
    const modalHeight = modalRect.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const minVisibleRight = modalWidth * 0.5; 
    const minVisibleLeft = modalWidth * -0.2;  
    const minVisibleBottom = modalHeight * 0.3; 
    const minVisibleTop = modalHeight * 0.9;
    
    let boundedX = x;
    let boundedY = y;
    
    if (x < -(modalWidth - minVisibleLeft)) {
      boundedX = -(modalWidth - minVisibleLeft);
    }
    
    if (x > windowWidth - minVisibleRight) {
      boundedX = windowWidth - minVisibleRight;
    }
    
    if (y < -(modalHeight - minVisibleTop)) {
      boundedY = -(modalHeight - minVisibleTop);
    }
    
    if (y > windowHeight - minVisibleBottom) {
      boundedY = windowHeight - minVisibleBottom;
    }
    
    setPosition({ x: boundedX, y: boundedY });
  };

  const handleChangeSubmit = (item) => {
    setTableId(item.tableId);
    setDatasetTableName(item.TBL_NAME)
    onConfirmOpen();
  };

  const handleConfirmChange = async () => {
    try {
      setSpinnerLoading(true);
      const body = {
        BearerToken: sessionStorage.getItem("token"),
        username: sessionStorage.getItem("username"),
        tableName: datasetTableName,
      }
      const options = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const urlFetch = `${react_api}/admin/deprecateDataset`;
      const response = await axiosInstance.post(urlFetch, body, options);

      const result = response.data;
      if (result.status === HTTP_STATUS_CODES.OK) {
        setCatalog(prevCatalog =>
          prevCatalog.map(item =>
            item.tableId === tableId ? { ...item, visibility: "deprecated" } : item
          )
        );
        onConfirmClose();
        toast({
          title: t('toastMsg.datasetPage.visibilityChangeSuccessful'),
          status: 'success',
          duration: 4000,
          isClosable: true
        });
      } 
      if (result.status !== HTTP_STATUS_CODES.OK) {
          toast({
              title: t('toastMsg.error'),
              description: t(`messageBE.${result.message}`),
              position: "top",
              status: 'error',
              duration: 4000,
              isClosable: true
          });
      }
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }finally{
      setSpinnerLoading(false);
    }
  }


  const handleDeleteClick = (item) => {
    setDatasetTableName(item.TBL_NAME)
    onDeleteOpen();
  };


  const handleConfirmDelete = async () => {
    try {
      setSpinnerLoading(true);
      const body = {
        BearerToken: sessionStorage.getItem("token"),
        username: sessionStorage.getItem("username"),
        tableName: datasetTableName,
      }
      const options = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const urlFetch = `${react_api}/admin/removeDataset`;
      const response = await axiosInstance.post(urlFetch, body, options);

      const result = response.data;
      if (result.status === HTTP_STATUS_CODES.OK) {
        setCatalog((prevCatalog) => prevCatalog.filter((catalogItem) => catalogItem.TBL_NAME !== datasetTableName));
        setCatalogCopy((prevCatalog) => prevCatalog.filter((catalogItem) => catalogItem.TBL_NAME !== datasetTableName));
        onDeleteClose();
        toast({
          title: t('toastMsg.datasetPage.datasetSuccessfullyDeleted'),
          status: 'success',
          duration: 4000,
          isClosable: true
        });
      } 
      if (result.status !== HTTP_STATUS_CODES.OK) {
          toast({
              title: t('toastMsg.error'),
              description: t(`messageBE.${result.message}`),
              position: "top",
              status: 'error',
              duration: 4000,
              isClosable: true
          });
      }
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }finally{
      setSpinnerLoading(false);
    }
  }

  return (
    <>
      {spinnerLoading && (
        <SpinnerXL />
      )}
      <Box alignItems={"center"} justifyContent={"space-between"} display={"flex"} color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"} >
        <Heading>Datasets</Heading>
        <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.previousPage')} placement="right" >
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            bg={"#f6f3ec"}>
            <MdArrowBack />
          </Button>
        </Tooltip>
        <Box>
          {t('catalog.dataset.page')} {currentPage}/{totalPages}<Spacer /> Dataset {startIndex} - {endIndex} {t('catalog.dataset.of')} {catalog.length}
        </Box>
        <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.nextPage')} placement="left" >
          <Button onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage * itemsPerPage >= catalog.length}
            bg={"#f6f3ec"} >
            <MdArrowForward />
          </Button>
        </Tooltip>
        <Box mr={100}>
          <Popover >
            <PopoverTrigger>
              {/* <Tooltip label="Search for a dataset" placement="left" closeOnClick={true} > */}
              <Button color={"rgba(11,78,90,255)"}
                bgColor={"#f6f3ec"}
                h={"100%"}>
                <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.searchDataset')} placement="left" closeOnClick={true}>
                  <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <Icon as={MdSearch} />
                    {t('catalog.dataset.search')}
                  </span>
                </Tooltip>
              </Button>
              {/* </Tooltip> */}
            </PopoverTrigger>
            <Portal>
              <PopoverContent bgColor={"white"} borderWidth={2} width="100%" borderColor={"#0888BE"}>
                <PopoverArrow />
                <PopoverHeader
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  color="rgba(11,78,90,255)"
                  fontSize="lg"
                  fontWeight="semibold"
                >
                  {t('catalog.dataset.searchTheTable')}
                  <PopoverCloseButton color="rgba(11,78,90,255)" mt="6px" />
                </PopoverHeader>
                <PopoverBody>
                  <Stack spacing='4'>
                    <Box>
                      <FormControl>
                        <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.filter')}:</FormLabel>
                        <Select
                          value={searchSelectedValue}
                          onChange={handleSelectSearchChange}
                          variant="filled"
                        >

                          <option value='datasetId' variant="filled">Dataset ID</option>
                          <option value='name' variant="filled" >{t('catalog.dataset.modal.name')}</option>
                          <option value='category' variant="filled" >{t('catalog.dataset.modal.category')}</option>
                          <option value='description' variant="filled">{t('catalog.dataset.modal.description')}</option>
                          <option value='manager' variant="filled" >Manager</option>
                          <option value='visibility' variant="filled">{t('catalog.dataset.modal.visibility')}</option>



                        </Select>
                      </FormControl>
                    </Box>
                    <Box>



                      {searchSelectedValue === "visibility" ?


                        (<CheckboxGroup colorScheme='green'
                          value={selectedSearchVisibilityValues}
                          onChange={handleSelectedSearchVisibilityValuesChange}
                        >
                          <Stack spacing={[1, 5]} direction={['column', 'row']}>
                            <Checkbox value='private'>{t('catalog.dataset.modal.private')}</Checkbox>
                            <Checkbox value='public'>{t('catalog.dataset.modal.public')}</Checkbox>
                            <Checkbox value='obtained'>{t('catalog.dataset.modal.obtained')}</Checkbox>
                            <Checkbox value='general'>{t('catalog.dataset.modal.general')}</Checkbox>
                            <Checkbox value='deprecated'>{t('catalog.dataset.modal.deprecated')}</Checkbox>
                          </Stack>
                        </CheckboxGroup>
                        ) : (

                          searchSelectedValue === "category" ? (
                            <Box>
                              <Checkbox
                                isChecked={allChecked}
                                isIndeterminate={isIndeterminate}
                                onChange={handleSelectAllChange}
                              >
                                {t('catalog.dataset.modal.selectDeselectAll')}
                              </Checkbox>
                              <Stack pl={6} mt={1} spacing={1}>



                                {categories.map((category, index) => (


                                  <Checkbox
                                    isChecked={searchCheckedCategories[index]}
                                    onChange={handleCategoryChange(index)}
                                  >
                                    {category}
                                  </Checkbox>


                                ))}
                              </Stack>
                            </Box>

                          )

                            : (

                              searchSelectedValue === "description" ? (

                                <Box><FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.enterDescription')}:</FormLabel>
                                  <Input variant='filled' placeholder='value' name='valueForSearch' type='text' bg='white' value={searchDescriptionInput} onChange={handleSearchDescriptionInput} /></Box>

                              ) : (


                                searchSelectedValue === "datasetId" ? (

                                  <Box><FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.enterDatasetId')}:</FormLabel>
                                    <Input variant='filled' placeholder='value' name='valueForSearch' type='text' bg='white' value={searchDatasetIdInput} onChange={handleSearchDatasetIdInput} /></Box>
                                ) : (
                                searchSelectedValue === "name" ? (

                                  <Box><FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.enterDatasetName')}:</FormLabel>
                                    <Input variant='filled' placeholder='value' name='valueForSearch' type='text' bg='white' value={searchNameInput} onChange={handleSearchNameInput} /></Box>
                                ) : (
                                  <Box><FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('catalog.dataset.modal.insertManager')}:</FormLabel>
                                    <Input variant='filled' placeholder='value' name='valueForSearch' type='text' bg='white' value={searchManagerInput} onChange={handleSearchManagerInput} /></Box>
                                )
                              )



                              )




                            )
                        )
                      }


                    </Box>
                  </Stack>

                </PopoverBody>
                <PopoverFooter display="flex" justifyContent="space-between" alignItems="center" gap={4}>
                  <Button colorScheme='green' onClick={applyFilterDataset} ><Icon as={MdSearch} />
                    {t('catalog.dataset.search')}
                  </Button>
                  <Button ml={4}
                    leftIcon={<Icon as={MdRestartAlt} fontSize="2xl" />} // Set the icon to the left of the text
                    colorScheme="teal" // Adjust the color scheme as needed
                    variant="solid" // Adjust the button variant
                    onClick={resetFilterDataset} // Attach the onClick handler
                  >Reset
                  </Button>

                </PopoverFooter>
              </PopoverContent>
            </Portal>
          </Popover>
          {/* <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.uploadDataset')} placement="bottom" >
            <Button color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"} h={"100%"} onClick={() => { onUploadModalOpen(); setPayloadUploadRequest(defaultPayloadUploadRequestValue) }}>
              <Icon as={MdUploadFile} />{t('catalog.dataset.upload')} dataset
            </Button>
          </Tooltip> */}
        </Box>

      </Box>


      <Box overflowY="auto" direction="column" h="100%" w="100%" boxShadow="lg">

        <TableContainer p={1}>
          <Table variant='striped' w="100%">
            <Thead bgColor={"#0888BE"} position="sticky" top="0">
              <Tr>
                <Th align="left" w={"5%"} color={"white"}>Dataset ID</Th>
                <Th align="left" w={"15%"} color={"white"}>{t('catalog.dataset.table.title')}</Th>
                <Th align="left" w={"15%"} color={"white"}>Datasets</Th>
                <Th color={"white"} w={"10%"} maxW="200px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" position="sticky" left="0" bgColor={"#0888BE"} zIndex="1"
                >{t('catalog.dataset.table.categories')}</Th>
                <Th color={"white"} w={"25%"} whiteSpace={"normal"} wordBreak={"break-word"}>{t('catalog.dataset.table.description')}</Th>
                <Th color={"white"} w={"10%"} whiteSpace={"normal"} wordBreak={"break-word"}>Manager</Th>
                <Th color={"white"} w={"10%"} whiteSpace={"normal"} wordBreak={"break-word"}>{t('catalog.dataset.table.visibility')}</Th>
                <Th color={"white"} w={"10%"}>{t('catalog.dataset.table.actions')}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {catalog.length > 0 ? (
                paginatedData.map((item, index) => {

                  //const categorie = item.category.split("\\"); 
                  return (

                    <Tr key={index}>
                      <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.ds_id}</Td>
                      <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.title}</Td>
                      <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.TBL_NAME}</Td>
                      <Td wordBreak={"break-word"} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" maxW="200px" position="sticky" left="0" bg="white" zIndex="1">
                        <VStack spacing={2} wrap="wrap" align="start">
                          {item.category.map((cat, idx) => (
                            <Tooltip key={idx} label={cat} hasArrow>
                              <Badge key={idx} color="black" border="1px solid #0888BE" bg="transparent" borderRadius="md" px={1} py={0} maxW="150px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" display="inline-block"
                              >{cat}</Badge>
                            </Tooltip>
                          ))}
                        </VStack>
                      </Td>
                      <Td whiteSpace={"normal"} wordBreak={"break-word"} >
                        <Tooltip label={item.description.length > 200 ? item.description : null} hasArrow placement="bottom-start" openDelay={300}maxW="1000px" whiteSpace="normal" >
                          <Text as="span" cursor="pointer">
                            {item.description.length > 200
                              ? (
                                <>
                                  {item.description.substring(0, 200)}
                                  <Text as="span" color="green.500"> ► </Text>
                                </>
                              )
                              : item.description
                            }
                          </Text>
                        </Tooltip>
                      </Td>
                      <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.OWNER}</Td>
                      <Td whiteSpace={"normal"} wordBreak={"break-word"}>  <Badge variant='solid' colorScheme={item.visibility === "private" ? "green" : item.visibility === "public" ? "yellow" : item.visibility === "obtained" ? "orange" : item.visibility === "deprecated" ? "red" : "blue"}>
                        {item.visibility}
                      </Badge></Td>

                      <Td w="15%" maxW="15%" overflow="hidden">
                        <HStack align={"center"} wrap="wrap">

                          <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.metadataView')} placement="bottom" closeOnClick={true}>
                            <Icon as={InfoIcon} onClick={() => visualizzaMetadati(item.tableId, item.TBL_NAME)} _hover={{ color: "#0888BE" }} />
                          </Tooltip>
                          {role === "Publisher" &&(
                            <>
                              <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.accessSemanticGraph')} shouldWrapChildren placement="bottom" closeOnClick={true}>
                                <Icon as={PiGraphFill} onClick={() => {navigate('/semantic-graph', { state: { data: item } });}} _hover={{ color: "#0888BE" }} />
                              </Tooltip>
                            </>
                          )}

                          {item.visibility === "public" || item.visibility === "general" || role === "Publisher"  ? (
                            <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.datasetView')} placement="bottom" closeOnClick={true}>
                              <Icon as={SearchIcon} _hover={{ color: "#0888BE" }} onClick={() => visualizzaDataset(item.tableId, item.TBL_NAME)} />
                            </Tooltip>
                          ) : item.visibility === "private" ? (
                            item.OWNER === sessionStorage.username ? (
                              <>
                                <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.datasetView')} placement="bottom" closeOnClick={true}>
                                  <Icon as={SearchIcon} _hover={{ color: "#0888BE" }} onClick={() => visualizzaDataset(item.tableId, item.TBL_NAME)} />
                                </Tooltip>
                                <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.shareDataset')} placement="bottom" closeOnClick={true}>
                                  <span>
                                    <Icon as={FaShareAlt} _hover={{ color: "#0888BE" }} onClick={() => getSharedUsers(item.TBL_NAME, item.tableId)} />
                                  </span>
                                </Tooltip>
                              </>
                            ) : null
                          ) : item.visibility === "obtained" ? (
                            <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.datasetView')} placement="bottom" closeOnClick={true}>
                              <Icon as={SearchIcon} _hover={{ color: "#0888BE" }} onClick={() => visualizzaDataset(item.tableId, item.TBL_NAME)} />
                            </Tooltip>
                          ) : null}
                          {item.visibility === "deprecated" ? (
                            <Tooltip label={t('toolTip.tooltipDataset.datasetHeader.thisDatasetWillSoonBeDeleted')} placement="bottom" bg="red.500">
                              <span>
                                <Icon color="red" as={IoWarning} _hover={{ color: "#be3508" }} />
                              </span>
                            </Tooltip>
                          ) : null}
                          {/* GEOPORTAL */}
                          {/* {item.OWNER === sessionStorage.getItem('username') && (
                            <Tooltip label={"Transfer to Geoportal"} placement="bottom" closeOnClick={true}>
                              <span>
                                <Icon
                                  disabled={true}
                                  mb={"0.5px"}
                                  boxSize={6}
                                  as={TbWorldUpload}
                                  _hover={{ color: "#0888BE" }}
                                  onClick={() => alert("Send To Geoportal")}
                                />
                              </span>
                            </Tooltip>
                          )} */}
                          {item.OWNER === sessionStorage.getItem('username') && (
                            <Tooltip label={"Transfer to Geoportal"} placement="bottom" closeOnClick={true}>
                              <span>
                                <Icon
                                  mb={"0.5px"}
                                  boxSize={6}
                                  as={TbWorldUpload}
                                  color="gray.400"
                                  cursor="not-allowed"
                                  pointerEvents="none"
                                />
                              </span>
                            </Tooltip>
                          )}


                          {/* FINE GEOPORTAL */}
                        </HStack>
                        <HStack mt={2}>
                          {role === "Publisher" && ( item.visibility === "private" || item.visibility === "public" || item.visibility === "general" ) &&(
                            <Tooltip label={t('toolTip.tooltipDataset.datasetActions.changeVisibility')} placement="bottom">
                              <span>
                                <Icon as={GiCardExchange } onClick={() => handleChangeSubmit(item)} color="red" cursor="pointer" _hover={{ color: 'red.500' }} />
                              </span>
                            </Tooltip>
                          )}
                          {role === "Publisher" && item.visibility === "deprecated"  &&(
                            <Tooltip label={t('toolTip.tooltipDataset.datasetActions.deleteDataset')} placement="bottom">
                              <span>
                                <Icon as={MdDelete} onClick={() => handleDeleteClick(item)} color="red" cursor="pointer" _hover={{ color: 'red.500' }} />
                              </span>
                            </Tooltip>
                          )}
                        </HStack>
                      </Td>

                    </Tr>);
                })) : (<Tr><Text fontSize={"lg"} fontWeight={"bold"}>{message ? t(`messageBE.${message}`) : ''}</Text></Tr>)}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      <Modal onClose={closeMetadataModal} isOpen={isMetadataModalOpen} isCentered scrollBehavior={scrollBehavior} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent maxW="60%" h="80%">
          <ModalHeader bgColor={"#0888BE"} color="yellowgreen" display="flex" justifyContent="space-between"><Box>Dataset metadata {t('catalog.dataset.modal.table.view')}: <Text fontSize={"lg"} fontWeight={"bold"} color="white">{metadataTableName}</Text>
          </Box>
            <Box display="flex" alignItems="center" gap={2}>

              <Button ml={2} onClick={openMetadataDescriptionModal} size="sm">{t('catalog.dataset.modal.columnDescriptionButton')}</Button>

              {
                metadata != null && metadata.id_validation_metadataml && (
                  <Button onClick={openMetadataModalValidationDatasetML} size="sm">MetaData ML</Button>
                )
              }


              <CloseButton onClick={closeMetadataModal} />
            </Box>
          </ModalHeader>

          {/* INIZIO METADATA VIEW */}
          {metadata ? (
            <ModalBody p={2}>
              <Box overflowY="auto">
                <Table size="sm" variant='unstyled' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={1}>
                    <Tr>
                      <Th color={"white"} border="2px solid white">Dataset id</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.datasetTitle')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.tableName')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.rawFileName')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.dataset_id == null ? ("-") : (metadata.dataset_id)}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.title == null ? ("-") : (metadata.title)}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.table_name == null ? ("-") : (metadata.table_name)}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.file_name == null ? ("-") : (metadata.file_name)}</Td>
                    </Tr>
                  </Tbody>
                </Table>
                <br />

                <Table size="sm" variant='unstyled' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={1}>
                    <Tr>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.dataManager')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.contactProvider')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.owner')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.publisher')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.data_manager == null ? ("-") : (metadata.data_manager)}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.contactProvider == null ? ("-") : (metadata.contactProvider)}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.owner == null ? ("-") : (metadata.owner)}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.publisher == null ? ("-") : (metadata.publisher)}</Td>
                    </Tr>
                  </Tbody>
                </Table>
                <br />

                <Table size="sm" variant='unstyled' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"}>
                    <Tr>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.description')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{metadata.description}</Td>
                    </Tr>
                  </Tbody>
                </Table>
                <br />

                <Table size="sm" variant='unstyled' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={1}>
                    <Tr>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.releaseDate')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.creationDate')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.lastModifiedDate')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.release_date == null ? ("-") : (convertUtcToLocal(metadata.release_date))}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.creation_date == null ? ("-") : (metadata.creation_date)}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.last_modified_date == null ? ("-") : (convertUtcToLocal(metadata.last_modified_date))}</Td>
                    </Tr>
                  </Tbody>
                </Table>
                <br />

{metadata.timeCoverage != null && metadata.timeCoverage.startDate && metadata.timeCoverage.endDate && (
  <>
                <Table size="sm" variant='unstyled' w="100%" h="100%">
  <Thead fontFamily="-moz-initial" bg="#0888BE" position="sticky" top="0" zIndex={1}>
    <Tr>
      <Th colSpan={2} textAlign="center" color="white" border="2px solid white">
        {t('catalog.dataset.modal.table.timeCoverage')}
      </Th>
    </Tr>
    <Tr>
      <Th color="white" border="2px solid white">{t('catalog.dataset.modal.table.startDate')}</Th>
      <Th color="white" border="2px solid white">{t('catalog.dataset.modal.table.endDate')}</Th>
    </Tr>
  </Thead>
  <Tbody>
    <Tr>
      <Td bg="gray.100" border="2px solid white" color="black" whiteSpace="normal" wordBreak="break-word">
        {metadata.timeCoverage == null ? "-" : new Date(metadata.timeCoverage.startDate.epoch).toISOString().split("T")[0]}
      </Td>
      <Td bg="gray.100" border="2px solid white" color="black" whiteSpace="normal" wordBreak="break-word">
        {metadata.timeCoverage == null ? "-" : new Date(metadata.timeCoverage.endDate.epoch).toISOString().split("T")[0]}
      </Td>
    </Tr>
  </Tbody>
</Table>      <br /> </>)}

                <Table size="sm" variant='unstyled' w={"100%"} h={"100%"}>
                  <Thead fontFamily={"-moz-initial"} bg={"#0888BE"}>
                    <Tr>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.field')}</Th>
                      <Th color={"white"} border="2px solid white">{t('catalog.dataset.modal.table.value')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.externalId')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.external_id == null ? ("-") : (metadata.external_id)}</Td>
                    </Tr>
                    <Tr>
                      <Td border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.internalVersion')}</Td>
                      <Td border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>
                        <Box display="flex" alignItems="center" gap="20px">
                          <Text>{metadata.current_version == null ? "-" : metadata.current_version}</Text>
                          <Text fontSize="sm" ml="50px">
                            {t('catalog.dataset.modal.table.dataUpdateDate')} : {metadata.external_update_date == null ? "-" : metadata.external_update_date}
                          </Text>
                        </Box>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.externalVersion')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.external_version == null ? ("-") : (metadata.external_version)}</Td>
                    </Tr>
                    <Tr>
                      <Td border="2px solid white" color={"black"}>Url</Td>
                      <Td border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.url == null ? ("-") : (metadata.url)}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>Source URLs</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.source_urls == null ? ("-") : (metadata.source_urls.join(', ') )}</Td>
                    </Tr>
                    <Tr>
                      <Td border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.referencedId')}</Td>
                      <Td border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.versionOf == null ? ("-") : (metadata.versionOf)}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.visibility')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.visibility == null ? ("-") : (metadata.visibility)}</Td>
                    </Tr>
                    <Tr>
                      <Td border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.encoding')}</Td>
                      <Td border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.encoding == null ? ("-") : (metadata.encoding)}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.isProcessed')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.prov_elab == null ? ("-") : (metadata.prov_elab)}</Td>
                    </Tr>
                    <Tr>
                      <Td color="black">{t('catalog.dataset.modal.table.tags')}</Td>
                      <Td color="black" whiteSpace="normal" wordBreak="break-word">
                        {Array.isArray(metadata.tags) && metadata.tags.length > 0 ? (
                          <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                              <thead>
                                <tr>
                                  <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", paddingBottom: "4px" }}>{t('catalog.dataset.modal.table.tagName')}</th>
                                  <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", paddingBottom: "4px" }}>{t('catalog.dataset.modal.table.tagDescription')}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {metadata.tags.map((tag, index) => (
                                  <tr key={index}>
                                    <td style={{ padding: "4px 8px", verticalAlign: "top" }}>{tag.name || "-"}</td>
                                    <td style={{ padding: "4px 8px", verticalAlign: "top" }}>{tag.description  || "-"}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          "-"
                        )}
                      </Td>
                    </Tr>

                   
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.licenseName')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.licence_name == null ? ("-") : (metadata.licence_name)}</Td>
                    </Tr>
                    <Tr>
                      <Td border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.latitude')}</Td>
                      <Td border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.latitude == null ? ("-") : (metadata.latitude)}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.longitude')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.longitude == null ? ("-") : (metadata.longitude)}</Td>
                    </Tr>
                    <Tr>
                      <Td border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.category')}</Td>
                      <Td border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.categories == null ? ("-") : (metadata.categories.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.pnrrThemes')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.pnrrThemes == null ? ("-") : (metadata.pnrrThemes.join(', '))}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>{t('catalog.dataset.modal.table.grinsThemes')}</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.grinsThemes == null ? ("-") : (metadata.grinsThemes.join(', '))}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>{t('catalog.dataset.modal.table.languages')}</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.languages == null ? ("-") : (metadata.languages.join(', '))}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Data Frequency</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.data_frequency == null ? ("-") : (metadata.data_frequency.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>Typology Source</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.typology_source == null ? ("-") : (metadata.typology_source.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Aggregation Level</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.level_aggregation == null ? ("-") : (metadata.level_aggregation.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>Geographical Coverage</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.geographical_coverage == null ? ("-") : (metadata.geographical_coverage.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td color={"black"}>Record Identifier</Td>
                      <Td color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.record_identifier == null ? ("-") : (metadata.record_identifier.toString())}</Td>
                    </Tr>
                    <Tr>
                      <Td bg="gray.100" border="2px solid white" color={"black"}>ID - Validation Metadata ML</Td>
                      <Td bg="gray.100" border="2px solid white" color={"black"} whiteSpace={"normal"} wordBreak={"break-word"}>{metadata.id_validation_metadataml == null ? ("-") : (metadata.id_validation_metadataml.toString())}</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Box>
            </ModalBody>
          ) : null}
        </ModalContent>
      </Modal>

      <Modal onClose={closeDatasetModal} isOpen={isDatasetModalOpen} isCentered scrollBehavior={scrollBehavior} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent maxW="90%" maxH="90vh" h="auto" position="absolute" top="10%" transform="translateY(-50%)">
          <ModalHeader bgColor={"#0888BE"} color="yellowgreen" display="flex" justifyContent="space-between">
            <Box>
              Dataset {t('catalog.dataset.modal.table.view')}:
              <Text fontSize={"lg"} fontWeight={"bold"} color="white">{datasetTableName}</Text>
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Button onClick={openMetadataDescriptionModal} size="sm">{t('catalog.dataset.modal.columnDescriptionButton')}</Button>
              <CloseButton onClick={closeDatasetModal} />
            </Box>
          </ModalHeader>
          <ModalBody p={1}>
            <Box overflowY="auto">
              <Table size="sm" variant='striped' w={"100%"} h={"100%"}>
                <Thead bgColor={"#0888BE"}>
                  <Tr>
                    {keys ? (
                      keys.map((key) => (
                        <Th color="white" key={key}>{key}</Th>
                      ))
                    ) : ("")}
                  </Tr>
                </Thead>
                <Tbody>
                  {datasetList && datasetList.length > 0 ? (
                    datasetList.map((item, index) => (
                      <Tr key={index}>
                        {keys.map((key) => {
                          const value = item[key];
                          const isDateKey = ["date", "data", "ora", "hour", "hours", "time"].some((word) =>
                            key.toLowerCase().includes(word)
                          );
                          const dateRegex = /^\d{4}-\d{2}-\d{2}T?\s?\d{2}:\d{2}:\d{2}/;
                          const isValidDate = typeof value === "string" && dateRegex.test(value);
                          return (
                            <Td key={key}>
                              {isDateKey && isValidDate ? convertUtcToLocal(value) : value}
                            </Td>
                          );
                        })}
                      </Tr>
                    ))
                  ) : (
                    ""
                  )}
                </Tbody>
              </Table>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal onClose={() => { onUploadModalClose(); setPayloadUploadRequest(defaultPayloadUploadRequestValue) }} isOpen={isUploadModalOpen} isCentered closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="white" display="flex" justifyContent="space-between" bgColor={"#0888BE"}><Box>{t('uploadDatasetModal.upload')} Dataset</Box> <Box><CloseButton onClick={() => { onUploadModalClose(); setPayloadUploadRequest(defaultPayloadUploadRequestValue); setIsUpdate(false) }} /></Box></ModalHeader>
          <ModalBody>
            <Stack spacing='4'>
              <Box>

                <FormControl mb={4} isRequired>
                  <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'> Dataset {t('uploadDatasetModal.version')}</FormLabel>
                  <NumberInput
                    min={1.0}
                    step={0.1}
                    precision={1}
                    defaultValue={1.0}

                    value={payloadUploadRequest.version} // Collega il valore allo stato 
                    onChange={(valueString) => handleChangePayloadRequest(valueString, 'version')}
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
                <FormControl display='flex' alignItems='center'>
                  <FormLabel htmlFor='email-alerts' mb='2'>
                    {t('uploadDatasetModal.isTheFileAnUpdate')}
                  </FormLabel>
                  <Switch id='email-alerts' onChange={(e) => handleChangePayloadRequest(e, "is_update")} />
                </FormControl>
                {isUpdate && (
                  <>
                    <Box bg="yellow.100" p={3} borderRadius="md">
                      <Text fontSize="sm" fontWeight="bold">
                        {t('uploadDatasetModal.msgFileUpdate')}
                      </Text>
                    </Box>
                    <FormControl mb={4} isRequired>
                      <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('uploadDatasetModal.updateDate')}</FormLabel>
                      <Input type="date" required onChange={(e) => handleChangePayloadRequest(e, 'updateDate')} />
                    </FormControl>
                  </>
                )}
                {!isUpdate && (
                  <FormControl isRequired mb={4}>
                    <Box>
                      <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('uploadDatasetModal.title')} :</FormLabel>
                      <Input placeholder='Titolo' onChange={(e) => handleChangePayloadRequest(e, "titolo")} />
                    </Box>
                  </FormControl>
                )}
                <FormControl isRequired>
                  <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('uploadDatasetModal.fileFormat')}:</FormLabel>
                  <Select onChange={(e) => handleChangePayloadRequest(e, "fileFormat")} >


                    {fileFormats.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}

                  </Select>
                </FormControl>


              </Box>

              {/* <FormControl display='flex' alignItems='center'>
                <FormLabel htmlFor='email-alerts' mb='0'>
                  {t('catalog.dataset.isTheFileAnUpdate')}
                </FormLabel>
                <Switch id='email-alerts' onChange={(e) => handleChangePayloadRequest(e, "is_update")} />
              </FormControl> */}
              <Box>


                <FormControl isRequired>
                  <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' >{t('uploadDatasetModal.selectFile')}:</FormLabel>
                  <Input ref={fileSelectorRef} placeholder='Select file' name='file' type='file' bg='white' accept={selectedFileFormat} onChange={(e) => handleChangePayloadRequest(e, "file")} />
                </FormControl>
              </Box>

            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='green' mr={3} onClick={uploadDataset}>
              {t('uploadDatasetModal.submit')}

            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal onClose={closeEditModal} isOpen={isEditDatasetModalOpen} isCentered size={"lg"} closeOnOverlayClick={false} >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bgColor={"#0888BE"} color="yellowgreen" display="flex" justifyContent="space-between"><Box><Text>{t('catalog.dataset.sharingDataset')}:</Text><Text color="white"> {datasetTableName}</Text></Box><CloseButton onClick={closeEditModal} /></ModalHeader>
          <ModalBody>
            <Table>
              <Tr><Text color={"#0888BE"} fontWeight={"bold"}>{t('catalog.dataset.enterUsername')}:</Text></Tr>
              <Tr>
                <Td><Input size="sm" onChange={handleChengeUsernameUser} borderWidth={1} borderColor={"black"}></Input></Td>
                <Td><Button colorScheme="green" onClick={() => shareWithUser()} >{t('catalog.dataset.share')}</Button></Td>
              </Tr>
              <Tr>


                <Table margin={2} >
                  <Tr > <Text color={"#0888BE"} fontWeight={"bold"} >{t('catalog.dataset.sharedUsers')}:</Text></Tr>
                  {sharedUsersList.length > 0 ?
                    (sharedUsersList.map((item, index) => (
                      <Tr><Text variant={"striped"}> • {item}</Text></Tr>
                    )
                    )




                    ) : (<Tr><Text fontWeight={"bold"} color={"black"}>{t('catalog.dataset.noSharedUsers')}</Text></Tr>)

                  }
                </Table></Tr>
            </Table>
          </ModalBody>
          <ModalFooter borderTopWidth={1} borderTopColor={"#0888BE"} display="flex" justifyContent="space-between" ><Text color={"#0888BE"} fontWeight={"bold"}>{t('catalog.dataset.makePublic')}:</Text><Button colorScheme="green" onClick={() => publishDataset()}>{t('catalog.dataset.publishDataset')}</Button></ModalFooter>
        </ModalContent>
      </Modal>

      {/* <Modal isOpen={isMetadataDescModalOpen} isCentered size={"xl"} scrollBehavior="inside" closeOnOverlayClick={false} >
        <ModalOverlay />
        <ModalContent maxW="55%" maxH="70vh" h="auto" position="absolute" >
          <ModalHeader bgColor={"#0888BE"} color="yellowgreen" display="flex" justifyContent="space-between"><Box>Dataset : <Text fontSize={"lg"} fontWeight={"bold"} color="white">{datasetTableName}</Text></Box><Box><CloseButton onClick={closeMetadataDescriptionModal} /> </Box></ModalHeader>
          <ModalBody tabIndex={0} p={1} overflowY="auto" maxH="calc(100vh - 200px)" onWheel={(e) => e.stopPropagation()}>

            <Table size="sm" variant='striped' w={"100%"} >
              <Thead bgColor={"#0888BE"}>
                <Tr >
                  <Th color="white" w="25%">{t('catalog.dataset.modal.columnName')}</Th>
                  <Th color="white" w="60%">{t('catalog.dataset.modal.columnDescription')}</Th>
                  <Th color="white" w="15%">{t('catalog.dataset.modal.columnType')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {metadataDescription.length > 0 ?
                  (metadataDescription.map((item, index) => (
                    <Tr key={index}>
                      <Td whiteSpace="normal" wordBreak="break-word" >
                        {item.name}
                      </Td>
                      <Td whiteSpace="normal" wordBreak="break-word">
                        {item.fielddescription}
                      </Td>
                      <Td whiteSpace="normal" wordBreak="break-word">
                        {item.type}
                      </Td>
                    </Tr>
                  ))) : ("")}
              </Tbody>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal> */}
      <Modal isOpen={isMetadataDescModalOpen} size="xl" scrollBehavior="inside" closeOnOverlayClick={false} motionPreset="none" >
        <Draggable handle=".modal-header" position={position} onDrag={handleDrag} onStop={handleDrag}>
          <ModalContent ref={modalRef} maxW="55%" maxH="70vh" h="auto" position="relative" zIndex={2}>
            <ModalHeader className="modal-header" bgColor="#0888BE" color="yellowgreen" display="flex" justifyContent="space-between" cursor="move">
              <Box>
                Dataset :{" "}
                <Text fontSize="lg" fontWeight="bold" color="white">
                  {datasetTableName}
                </Text>
              </Box>
              <Box>
                <CloseButton onClick={closeMetadataDescriptionModal} />
              </Box>
            </ModalHeader>
            <ModalBody tabIndex={0} p={1} overflowY="auto" maxH="calc(100vh - 200px)" onWheel={(e) => e.stopPropagation()}>
              <Table size="sm" variant="striped" w="100%">
                <Thead bgColor="#0888BE">
                  <Tr>
                    <Th color="white" w="25%">{t('catalog.dataset.modal.columnName')}</Th>
                    <Th color="white" w="60%">{t('catalog.dataset.modal.columnDescription')}</Th>
                    <Th color="white" w="15%">{t('catalog.dataset.modal.columnType')}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {metadataDescription.length > 0 ? (
                    metadataDescription.map((item, index) => (
                      <Tr key={index}>
                        <Td whiteSpace="normal" wordBreak="break-word">
                          {item.name}
                        </Td>
                        <Td whiteSpace="normal" wordBreak="break-word">
                          {item.fielddescription}
                        </Td>
                        <Td whiteSpace="normal" wordBreak="break-word">
                          {item.type}
                        </Td>
                      </Tr>
                    ))
                  ) : null}
                </Tbody>
              </Table>
            </ModalBody>
          </ModalContent>
        </Draggable>
      </Modal>



      <Modal isOpen={isMetadataModalValidationDatasetML} isCentered size={"lg"} scrollBehavior="inside" closeOnOverlayClick={false} >
        <ModalOverlay />
        <ModalContent maxW="40%" h="50%" position="absolute" top="35%" transform="translateY(-50%)">
          <ModalHeader bgColor={"#0888BE"} color="yellowgreen" display="flex" justifyContent="space-between"><Box>Metadata ML Dataset : <Text fontSize={"lg"} fontWeight={"bold"} color="white">{datasetTableName}</Text></Box><Box><CloseButton onClick={() => setMetadataModalValidationDatasetML(false)} /> </Box></ModalHeader>
          <ModalBody tabIndex={0} overflowY="auto" maxH="calc(100vh - 200px)" onWheel={(e) => e.stopPropagation()}>

            <Table size="sm" variant="striped" w="100%">
              <Thead bgColor="#0888BE">
                <Tr>
                  {headersMetaDataML.slice(0, 3).map(header => (
                    <Th
                      key={header}
                      color="white"

                    >
                      {header}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {metadataValidationDatasetML.map((row, rowIndex) => (
                  <Tr key={rowIndex}>
                    {headersMetaDataML.slice(0, 3).map(header => (
                      <Td
                        key={header}

                      >
                        {Array.isArray(row[header])
                          ? row[header].join(', ')
                          : String(row[header])}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table><br />



            <Table size="sm" variant="striped" w="100%">
              <Thead bgColor="#0888BE">
                <Tr>
                  {headersMetaDataML.slice(3, 6).map(header => (
                    <Th
                      key={header}
                      color="white"

                    >
                      {header}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {metadataValidationDatasetML.map((row, rowIndex) => (
                  <Tr key={rowIndex}>
                    {headersMetaDataML.slice(3, 6).map(header => (
                      <Td
                        key={header}

                      >
                        {Array.isArray(row[header])
                          ? row[header].join(', ')
                          : String(row[header])}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table><br />

            <Table size="sm" variant="striped" w="100%">
              <Thead bgColor="#0888BE">
                <Tr>
                  {headersMetaDataML.slice(6, 9).map(header => (
                    <Th
                      key={header}
                      color="white"

                    >
                      {header}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {metadataValidationDatasetML.map((row, rowIndex) => (
                  <Tr key={rowIndex}>
                    {headersMetaDataML.slice(6, 9).map(header => (
                      <Td
                        key={header}

                      >
                        {Array.isArray(row[header])
                          ? row[header].join(', ')
                          : String(row[header])}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>


            <br />

            <Table size="sm" variant="striped" w="100%">
              <Thead bgColor="#0888BE">
                <Tr>
                  {headersMetaDataML.slice(9, 12).map(header => (
                    <Th
                      key={header}
                      color="white"

                    >
                      {header}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {metadataValidationDatasetML.map((row, rowIndex) => (
                  <Tr key={rowIndex}>
                    {headersMetaDataML.slice(9, 12).map(header => (
                      <Td
                        key={header}

                      >
                        {Array.isArray(row[header])
                          ? row[header].join(', ')
                          : String(row[header])}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>


          </ModalBody>
        </ModalContent>
      </Modal>
        {/* Modal: Confirm Change */}
        <Modal isOpen={isConfirmOpen} onClose={onConfirmClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t('catalog.dataset.modal.confirmChange')}</ModalHeader>
            <ModalBody>
              <Text>
                {t('catalog.dataset.modal.confirmChangingVisibilityFor')} <b>{datasetTableName}</b> {t('catalog.dataset.modal.to')} 
                <Badge variant='solid' colorScheme={ "red"}>
                  DEPRECATED
                </Badge>
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={onConfirmClose}>{t('catalog.dataset.modal.cancel')}</Button>
              <Button colorScheme="green" onClick={handleConfirmChange}>{t('catalog.dataset.modal.confirm')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Modal: Confirm Delete */}
        <Modal isOpen={isDeleteOpen} onClose={onDeleteClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t('catalog.dataset.modal.deleteDataset')}</ModalHeader>
            <ModalBody>
              <Text>
                {t('catalog.dataset.modal.areYouSureYouWantToDelete')} <b>{datasetTableName}</b>?
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={onDeleteClose}>{t('catalog.dataset.modal.cancel')}</Button>
              <Button colorScheme="red" onClick={handleConfirmDelete}>{t('catalog.dataset.modal.delete')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
    </>
  );
}

export default DatasetPage;
